import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  //   OLD CODE
  title: {
    marginBottom: 15,
    fontSize: 15,
    textAlign: "center",
    fontFamily: "timesnewroman_bold",
  },
  title_italic: {
    marginBottom: 15,
    fontSize: 15,
    textAlign: "center",
    fontFamily: "timesnewroman_bold_italic",
  },
  normal: {
    marginBottom: 5,
    fontSize: 10,
    fontFamily: "timesnewroman_regular",
  },
  normal_italic: {
    marginBottom: 5,
    fontSize: 10,
    fontFamily: "timesnewroman_italic",
  },
  normal_bold: {
    marginBottom: 5,
    fontSize: 10,
    fontFamily: "timesnewroman_bold",
  },
  normal_bold_italic: {
    marginBottom: 5,
    fontSize: 10,
    fontFamily: "timesnewroman_bold_italic",
  },
  //   NEW CODE
  notetext: {
    marginTop: 10,
    fontSize: 10,
    textAlign: "center",
    fontFamily: "Helvetica-Oblique",
  },
  textBold: {
    marginLeft: 10,
    marginTop: 10,
    fontSize: 10,
    fontFamily: "Helvetica-Bold",
    textAlign: "left",
  },
  textNote: {
    marginLeft: 10,
    marginTop: 5,
    marginBottom: 8,
    fontSize: 10,
    fontFamily: "Helvetica",
    lineHeight: "1.5px",
    textAlign: "left",
  },

  textCancel: {
    marginLeft: 10,
    marginTop: 2,
    marginBottom: 2,
    fontSize: 10,
    fontFamily: "Helvetica",
    lineHeight: "1.5px",
    textAlign: "left",
  },
  textCancelLeft: {
    marginLeft: 30,
    marginTop: 2,
    marginBottom: 2,
    fontSize: 10,
    fontFamily: "Helvetica",
    lineHeight: "1.5px",
    textAlign: "left",
  },
});
